"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bearerToken = exports.toSearchParams = exports.isRunnable = exports.isRunnableResource = void 0;
const constants_1 = require("./constants");
function isRunnableResource(resource) {
    return isRunnable(resource === null || resource === void 0 ? void 0 : resource.kind);
}
exports.isRunnableResource = isRunnableResource;
function isRunnable(kind) {
    return constants_1.runnableKinds.includes(kind);
}
exports.isRunnable = isRunnable;
function toSearchParams(obj) {
    const search = new URLSearchParams();
    Object.entries(obj).forEach(([key, value]) => {
        if (key !== "id" && value !== null && value !== undefined) {
            search.set(key, value.toString());
        }
    });
    return search;
}
exports.toSearchParams = toSearchParams;
function bearerToken(tokenValue) {
    return `Bearer ${tokenValue}`;
}
exports.bearerToken = bearerToken;
